import React from "react";
import { Route, Routes } from "react-router-dom";
import { IOrderItem } from "../../../../modules/API/Drivers/models/kavData";
import KavCustomersPage from "./pages/KavCustomersPage";
import KavListPage from "./pages/KavListPage";
import { DriversProvider } from "./services/DriversContext";

/**
 * Контракт модалки разбора проблем. Тип объявлен здесь исторически и
 * импортируется в том числе из модуля teudotProblems, который рендерит
 * ту же ProblemHandleModal — не переносить и не удалять.
 */
export interface ISelectedProblem {
  kavID: number;
  CustomerID: number;
  item: IOrderItem[];
}

const DriversMain = () => (
  <DriversProvider>
    <Routes>
      <Route index element={<KavListPage />} />
      <Route path=":areaId" element={<KavCustomersPage />} />
    </Routes>
  </DriversProvider>
);

export default DriversMain;
